/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBoostConfigDirect} from '../api'

 export const useQueryGetBoostConfigDirect = createReactQueryHook('getBoostConfigDirect', getBoostConfigDirect)
